import React from "react";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import MarketoForm from "@qlik/qlik/src/components/MarketoForm/MarketoForm";
import { TYPE_MARKETO_FORM } from "@qlik/qlik/src/lib/constants/contentful-types";
import { renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";
import * as styles from "./styles.module.css";

const FooterCTAForm = ({ data }) => {
    const { additionalConfiguration, backgroundColor, backgroundImage = [], cardItems = [], customId } = data ?? {};
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration, "py-30 px-3.75");
    const { sectionColorMapping } = getColorClassName(backgroundColor);
    const formCard = cardItems?.find((card) => card?.__typename === TYPE_MARKETO_FORM);

    return (
        <section
            className={`${sectionSpacingClassName} relative z-1 px-3.75 bg-no-repeat ${
                styles.section
            }  ${sectionColorMapping?.bgColor || "bg-ocean"}`}
            id={customId}
        >
            <div className="container relative">
                <div className="row">
                    <div
                        style={{
                            backgroundImage:
                                backgroundImage?.length > 0 ? `url(${backgroundImage?.[0]?.secure_url})` : "none",
                        }}
                        className={`bg-no-repeat top-[156px] lg:top-[98px] w-82.5 lg:w-268.75  h-[90px] lg:h-[427px] absolute ${styles.bgContainer}`}
                    />
                    <div className="col-12 md:col-6 pr-3.75">
                        {cardItems?.map((card) => (
                            <h2
                                key={card.id}
                                className="text-white"
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(card.title) }}
                            />
                        ))}
                    </div>
                    {formCard && (
                        <div className="col-12 md:col-6 max-md:mt-10">
                            <MarketoForm {...formCard} isDark="false" />
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default FooterCTAForm;
